/**
 * @file: preshing-phone-format.pipe.ts
 * @since: 17-Oct-2017
 * @desc: PershingPhoneFormatPipe pipe is used to formate simple phone number into
 *        (AreaCode) (PhoneNumber) format.
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * @whatItDoes Format the given phone into (AreaCode) (PhoneNumber) format
 * @howToUse: {{ output | pershingPhoneFormatPipe }}
 * @desc
 *  input as 10 digit PPP####### -> output as (PPP) ###-####
 *  input as 11 digit CPPP####### -> CCC (PP) ###-####
 *  input as 12 digit CCCPP####### -> CCC (PP) ###-####
 */

@Pipe({
    name: 'pershingPhoneFormat'
})
export class PershingPhoneFormatPipe implements PipeTransform {
    transform(tel: any): string {

        if (!tel) {
            return '';
        }

        let value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        let country, city, phoneNumber;

        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                phoneNumber = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                phoneNumber = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                phoneNumber = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country === 1) {
            country = '';
        }

        phoneNumber = phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3);
        return `${country} (${city}) ${phoneNumber}`.trim();
    }
}
